import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function About() {
  const [providers, setProviders] = useState([]);
  useEffect(() => { api.get("/providers").then(({data})=>setProviders(data)); }, []);

  return (
    <div data-testid="about-page">
      <section className="section-y pb-8">
        <div className="container-x max-w-3xl">
          <div className="overline">About Restore Wellness</div>
          <h1 className="font-display text-5xl lg:text-6xl text-sage-800 mt-4 text-balance">Wellness should be personal.</h1>
          <p className="mt-6 text-lg text-sage-800/70 leading-relaxed">
            At Restore Wellness, we believe feeling your best shouldn't come from a one-size-fits-all approach. We help clients understand their options and build sustainable routines designed around their individual goals.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x">
          <div className="grid lg:grid-cols-5 gap-4 mb-20">
            <div className="lg:col-span-3 rounded-3xl overflow-hidden aspect-[4/3]"><img src="https://restorergv.com/wp-content/uploads/2024/11/restore-wellness-team-1024x683.jpg" alt="Team" className="w-full h-full object-cover" /></div>
            <div className="lg:col-span-2 rounded-3xl overflow-hidden aspect-[4/3]"><img src="https://images.unsplash.com/photo-1611920629515-3f76f8c36b37?w=900" alt="Space" className="w-full h-full object-cover" /></div>
          </div>

          <div className="mb-10">
            <div className="overline">Meet the team</div>
            <h2 className="font-display text-3xl lg:text-4xl text-sage-800 mt-3">Steve & Lilly</h2>
          </div>
          <div className="grid lg:grid-cols-2 gap-6">
            {providers.map((p) => (
              <div key={p.id} className="rounded-3xl bg-white border border-sand-200/60 p-6 flex gap-5 items-start card-lift" data-testid={`provider-${p.id}`}>
                <img src={p.photo} alt={p.name} className="w-24 h-24 rounded-2xl object-cover shrink-0" />
                <div>
                  <div className="overline text-clay-600">{p.role}</div>
                  <div className="font-display text-2xl text-sage-800 mt-1">{p.name}</div>
                  <div className="text-sm text-sage-800/70 mt-2 leading-relaxed">{p.intro}</div>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {p.focus_areas?.map(f=>(<span key={f} className="text-xs px-2.5 py-1 rounded-full bg-sand-100 text-sage-800/80">{f}</span>))}
                  </div>
                  <Button asChild className="btn-pill h-10 px-5 mt-5 bg-sage-700 hover:bg-sage-800 text-white text-sm"><Link to={`/book/consult?provider=${p.id}`}>Book with {p.name.split(' ')[0]}</Link></Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
